import request from '@/src/apis/axios';
import {
  GetCommunityPostingByIdRequestParams,
  GetCommunityPostingsRequestParams,
  PostCommunityPostingCategoryRequestBody,
} from '@/src/apis/rest/communityPosting.dtos';
import CommunityCategoryDto from '@/src/models/CommumityCategoryDto';
import CommunityPostingDto from '@/src/models/CommunityPostingDto';
import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';

const URL = {
  communityPosting: '/admin/community-postings',
  communityPostingCategory: '/community-postings/categories',
  communityPostingCategoryPut: '/admin/community-postings/categories',
  communityPostingDetail: '/admin/community-postings/{id}',
  communityPostingExcel: '/admin/community-postings/excel/export',
};

// 커뮤니티 게시글 리스트 조회
export const getCommunityPostingsAPI = async (
  requestParams: Partial<GetCommunityPostingsRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<CommunityPostingDto>>({
    method: 'get',
    url: URL.communityPosting,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(CommunityPostingDto, data.rows);

  return { rows, count: data.count };
};

// 커뮤니티 카테고리 조회
export const getCommunityPostingCategoriesAPI = async () => {
  const { data } = await request<ListResponse<CommunityCategoryDto>>({
    method: 'get',
    url: URL.communityPostingCategory,
  });

  return data.rows;
};

// 커뮤니티 카테고리 등록 및 수정
export const postCommunityPostingCategoryAPI = async (
  requestBody: PostCommunityPostingCategoryRequestBody,
) => {
  const { data } = await request<ObjectResponse<CommunityCategoryDto>>({
    method: 'put',
    url: URL.communityPostingCategoryPut,
    requestBody,
  });

  return data.row;
};

// 커뮤니티 게시글 상세 조회
export const getCommunityPostingByIdAPI = async ({
  id,
}: GetCommunityPostingByIdRequestParams) => {
  const { data } = await request<ObjectResponse<CommunityPostingDto>>({
    method: 'get',
    url: URL.communityPostingDetail.replace('{id}', String(id)),
  });

  const row = plainToInstance(CommunityPostingDto, data.row);

  return row;
};

// 커뮤니티 게시글 리스트 엑셀 다운로드
export const getCommunityPostingExcelAPI = async (
  password: string,
  requestParams: Partial<GetCommunityPostingsRequestParams>,
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.communityPostingExcel,
    queryParams: { ...requestParams, password },
    config: { responseType: 'blob' },
  });

  return data;
};
